import React, { createContext } from "react";
// hooks
import useLocalStorage from "../hooks/useLocalStorage";

const initialState = {
  themeMode: "light",
  themeStretch: true,
  onChangeMode: () => {},
};

const SettingsContext = createContext(initialState);

type Props = {
  children: React.ReactNode;
};

function SettingsProvider({ children }: Props) {
  const [settings, setSettings] = useLocalStorage("admin_settings", {
    themeMode: initialState.themeMode,
    themeStretch: initialState.themeStretch,
  });

  const onChangeMode = (event) => {
    setSettings({
      ...settings,
      themeMode: event.target.value,
    });
  };

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        // Mode
        onChangeMode,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export { SettingsProvider, SettingsContext };
